import { format } from 'date-fns';
import { ReviewPayload } from '../../../api/school_review';
import { ReviewerType } from '../../../enums';
import { FunderFormValues } from './types/FunderFormValues';
import { StudentFormValues } from './types/StudentFormValues';

export const valuesToPayload = (schoolId: string, values: FunderFormValues | StudentFormValues): ReviewPayload => {
  if (values.reviewerType === ReviewerType.Student) {
    const valuesData = values as StudentFormValues;
    const {
      stars,
      textareaField,
      firstName,
      lastName,
      email,
      reception,
      information,
      teaching,
      availability,
      quality,
      licenseType,
      isAgreed,
      drivingLessons,
      drivingExams,
      theoryExams,
      fullCost,
      selectedSchoolId,
      practicalExamDate,
      allowMaifProposal,
      reviewerType,
    } = valuesData;
    const examDate = format(practicalExamDate, 'yyyy-MM-dd');

    return {
      allow_maif_proposal: allowMaifProposal,
      availability,
      comment: textareaField,
      conditions_accepted: isAgreed ? '1' : '0',
      email,
      firstname: firstName,
      full_cost: fullCost,
      information,
      lastname: lastName,
      license_type: licenseType,
      nb_of_driving_exam: drivingExams,
      nb_of_driving_lesson: drivingLessons,
      nb_of_theory_exam: theoryExams,
      practical_exam_date: examDate,
      quality,
      reception,
      school_id: selectedSchoolId || schoolId,
      stars,
      teaching,
      reviewer_type: reviewerType,
    };
  }

  const valuesData = values as FunderFormValues;
  const {
    stars,
    offer,
    estimate,
    documents,
    indulgence,
    billing,
    comment,
    conditionsAccepted,
    reviewerType,
    selectedSchoolId,
    lastName,
    firstName,
    email,
  } = valuesData;
  return {
    stars,
    offer,
    estimate,
    documents,
    indulgence,
    billing,
    comment,
    conditions_accepted: conditionsAccepted ? '1' : '0',
    school_id: selectedSchoolId || schoolId,
    lastname: lastName,
    firstname: firstName,
    email,
    reviewer_type: reviewerType,
  };
};
